import React from 'react';
import { Route } from 'react-router-dom';

import { RoutePathProps } from '../../../AppRoutes/types';
import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned';
import ListProductReturn from '../pages/ListProductReturn';
import CreateEditProductReturn from '../pages/CreateEditProductReturn';
import ShowProductReturn from '../pages/ShowProductReturn';


// import EditProduct from '../pages/EditProduct';

const productReturn: RoutePathProps = {
  name: "productReturn",
  path: "/productReturn",
  label: "Return & Replacement",
  icon: AssignmentReturnedIcon,
  visibleInNav: true,
  requiredPermission:'product-return:list',
  children: [
    {
      name: "showProductReturn",
      path: "/productReturn/:id",
      label: "Show Product Return",
      icon: AssignmentReturnedIcon,
      requiredPermission:'product-return:read'
    },
    {
      name: "createProductReturn",
      path: "/productReturn/createProductReturn",
      label: "Create ProductReturn",
      icon: AssignmentReturnedIcon,
      requiredPermission:'product-return:create'
    },
    {
      name: "editProductReturn",
      path: "/productReturn/editProductReturn/:id",
      label: "Edit Product Return",
      icon: AssignmentReturnedIcon,
      requiredPermission:'product-return:update'
    },
    {
      name: "listProductReturn",
      path: "/productReturn/listProductReturn",
      label: "List Product Return",
      icon: AssignmentReturnedIcon,
      requiredPermission:'product-return:list'
    }
  ],
};

const ProductReturnRoutes = (
  <>
    <Route path={productReturn.path} element={<ListProductReturn />} />
    <Route path={productReturn.children?.[0].path} element={<ShowProductReturn />} />
    <Route path={productReturn.children?.[1].path} element={<CreateEditProductReturn />} />
    <Route path={productReturn.children?.[2].path} element={<CreateEditProductReturn />} />
    {/* <Route path={enquiry.children?.[2].path} element={<AddProduct />} /> */}
    <Route path={productReturn.children?.[3].path} element={<ListProductReturn />} />

  </>
);
export const productReturnPaths = [productReturn];
export default ProductReturnRoutes;
